import { c } from '../../../utils/tailwind-merge';
import { ChipList } from '../../molecules/ChipList/ChipList';
import type { RelatedKeywordsProps } from './RelatedKeywords.types';

const baseClasses = 'mt-8';

export const RelatedKeywords = ({
  items,
  link,
  className = '',
  microcopy,
  onClickChipList,
}: RelatedKeywordsProps) => {
  return (
    <div className={c('w-full', className)}>
      <h2 className="text-md font-medium text-content">{microcopy.title}</h2>
      <div className={c(baseClasses, 'mb-16')}>
        <ChipList items={items} link={link} onClickChipList={onClickChipList} />
      </div>
    </div>
  );
};
